module.exports = __webpack_public_path__ + "static/media/Botulinum_Toxin_Reading_List.f20a488d.zip";